<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />


    <div class="form-edit-page row-space">
        <div class="row row-space">
            <div class="form-item-char10">
                <label class="label-caption">Protocolo</label>
                <div class="field-label field-label-end">{{ Funcoes.formatInteger(objEdicao.cdagenda) }}</div>
            </div>

            <div class="form-item-data">
                <label class="label-caption">Data</label>
                <input type="date" v-model="objEdicao.dtagenda" />
            </div>

            <div class="form-item-char05">
                <label class="label-caption">Hora</label>
                <input type="text" class="input-center" v-time-mask v-model="objEdicao.hragenda" />
            </div>     

            <div class="form-item">
                <GabinetePessoaFrame
                    :init-id="idPessoaInit"
                    v-model:idSelecionado="objEdicao.idgabinete_pessoa" />
            </div>
        </div>


        
        <div class="row row-space"> 
            <div class="form-item">
                <label class="label-caption">Assunto</label>
                <input type="text" v-model="objEdicao.assunto" maxlength="100" v-uppercase />
            </div>

            <div class="form-item-char20">
                <GabineteAgendaTipoSelect v-model:opcaoSelecionada="objEdicao.cdtipo" />
            </div>

            <template v-if="objEdicao.id === 0">
                <div class="form-item-char30">
                    <label class="label-caption">Situação</label>
                    <select v-model="opcaoSelecionada">
                        <option v-for="opcao in lsOpcoes" :key="opcao.id" :value="opcao.id">{{ opcao.descricao }}</option>
                    </select>
                </div>
            </template>
        </div>


        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption">Detalhamento</label>
                <textarea v-model="objEdicao.detalhamento" maxlength="1000" rows="5" style="resize: none;"/>
            </div>
        </div>
        

        <div class="row-end">
            <button v-if="objEdicao.cdagenda===0" class="btn-confirm" @click="gerarProtocolo">Protocolar</button>
            <button v-if="objEdicao.cdagenda!=0" class="btn-confirm" @click="finalizarAgenda">Finalizar</button>
            <button class="btn-cancel" type="cancel" @click="cancelForm">Cancelar</button>
        </div>
    </div>    


    <div v-if="showPessoas">
        <div class="form-edit-page row-space">
            <div class="row row-space">
                <div class="form-item">
                    <GabinetePessoaFrame v-model:objSelecionado="pessoaSelecionada"/>
                </div>

                <button class="btn-confirm" @click="incluirPessoa">Incluir Participante</button>
            </div>

            <div v-if="lsPessoas.length>0" class="table-wrapper"><table>
                <thead><tr>
                    <th class="col-width-char15">CPF</th>
                    <th>Nome</th>
                    <th class="col-width-fone">Celular</th>
                    <th class="col-width-char40">Empresa</th>
                    <th class="col-width-char05"></th>
                </tr></thead>
                <tbody>
                    <tr v-for="(obj, index) in lsPessoas" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0}">
                        <td class="col-width-char15 center">{{ obj.cpf }}</td>
                        <td>{{ obj.nmpessoa }}</td>
                        <td class="col-width-fone center">{{ obj.celular }}</td>
                        <td class="col-width-char40">{{ obj.empresa_nome }}</td>
                        <td class="col-width-char05"><div class="row-center">
                            <button class="btn-icon btn-icon--trash" @click="excluiPessoa(obj)"></button>
                        </div></td>
                    </tr>
                </tbody>
            </table></div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { criarGabineteAgenda } from '@/models/GabineteAgenda';
import { Funcoes } from '@/funcoes/utils';
import { globalStore } from '@/globals';
import { Validacoes } from '@/funcoes/validacoes';
import GabineteAgendaTipoSelect from '@/selects/estaticos/GabineteAgendaTipoSelect.vue';
import GabinetePessoaFrame from '@/components/frames/GabinetePessoaFrame.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';

const emit=defineEmits(['close', 'salvo'])
const props=defineProps({
    idEdicao: {type: Number, default: 0},
    strData: {type: String, default: null}})

const msgAlerta = ref(false);
const objEdicao = criarGabineteAgenda();
const idPessoaInit = ref(null);
const isLoading = ref(false);
const lsPessoas = ref([]);
const showPessoas = ref(false);

const pessoaSelecionada = ref(null);


const lsOpcoes = ref([
    {id: 'AGENDADO',        descricao: 'AGENDADO'},
    {id: 'CONFIRMADO',      descricao: 'CONFIRMADO'},
    {id: 'AGUARDANDO',      descricao: 'AGUARDANDO'},
]);
const opcaoSelecionada = ref('AGENDADO');


const cancelForm = () => {emit('close');}

async function excluiPessoa(obj){
    try{
        msgAlerta.value=null;
        isLoading.value=true;
        await Api.genericPost('/gabinete/agenda/delcpf', {
            idmunicipio: globalStore.idmunicipio,
            intparam1: objEdicao.id,
            strparam1: obj.cpf,
            idlogin: globalStore.idlogin});
        await lerPessoas();
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    }finally{isLoading.value=false;}
}


const finalizarAgenda = async () => {
    try {
        msgAlerta.value=null;
        Validacoes.validarData(objEdicao.dtagenda);
        Validacoes.validarHora(objEdicao.hragenda);
        Validacoes.validarTexto(objEdicao.assunto, 'Informe o assunto');
        isLoading.value=true;
        const response = await Api.genericPut('/cad/gabinete_agenda', objEdicao);
        if (response.bolok===1){
            emit('salvo');
            emit('close');
        }else{
            msgAlerta.value = response.erro;
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally {isLoading.value=false;}
};


const gerarProtocolo = async() => {
    try {
        msgAlerta.value=null;
        Validacoes.validarData(objEdicao.dtagenda);
        Validacoes.validarHora(objEdicao.hragenda);
        Validacoes.validarTexto(objEdicao.assunto, 'Informe o assunto');
        isLoading.value=true;
        if (objEdicao.id===0){
            if (opcaoSelecionada.value === 'CONFIRMADO') objEdicao.lgconfirmacao = globalStore.idlogin;
            if (opcaoSelecionada.value === 'AGUARDANDO') objEdicao.lgchegada = globalStore.idlogin;
        }
        const response = await Api.genericPut('/cad/gabinete_agenda', objEdicao);
        if (response.bolok===1){
            const req = await Api.getCadastroById('gabinete_agenda', response.id);
            Object.assign(objEdicao, req[0]);
            objEdicao.hragenda = Funcoes.formatTimeFromJson(objEdicao.hragenda);
            showPessoas.value=true;
        }else{
            msgAlerta.value = response.erro;
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally {isLoading.value=false;}            
}


const incluirPessoa = async() =>{
    try {
        msgAlerta.value=null;
        if (!pessoaSelecionada.value) throw new Error('Informe o participante');
        isLoading.value=true;
        await Api.genericPost('/gabinete/agenda/addpessoa', {
            idmunicipio: globalStore.idmunicipio,
            id: objEdicao.id,
            idpessoa: pessoaSelecionada.value.id,
            idlogin: globalStore.idlogin});
        await lerPessoas();
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally {isLoading.value=false;}
}


const lerDados = async() => {
    try{
        isLoading.value=true;
        msgAlerta.value=null;

        if (props.idEdicao > 0) {
            try{
                const req = await Api.getCadastroById('gabinete_agenda', props.idEdicao);
                Object.assign(objEdicao, req[0]);
                showPessoas.value=true;
                objEdicao.hragenda = Funcoes.formatTimeFromJson(objEdicao.hragenda);
                idPessoaInit.value = objEdicao.idgabinete_pessoa;
                await lerPessoas();
            }catch (error){msgAlerta.value = error}
        }else{
            objEdicao.dtagenda = (props.strData) ? Funcoes.strDataIsoFromString(props.strData) : Funcoes.dataAtual();
            objEdicao.hragenda = Funcoes.strHoraAtual();
            objEdicao.idmunicipio = globalStore.idmunicipio;
            objEdicao.idlogin = globalStore.idlogin;
        }
        objEdicao.idusuario     = globalStore.idusuario;
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    }finally{isLoading.value=false;}
}


async function lerPessoas() {
    try{
        isLoading.value=true;
        msgAlerta.value=null;
        const req = await Api.genericPost('/listas/gabinete_pessoas', {
            idmunicipio: globalStore.idmunicipio, 
            intparam1: objEdicao.id});
        lsPessoas.value = req;
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    }finally{isLoading.value=false;}
}


onMounted(lerDados)
</script>